import { render, staticRenderFns } from "./RutherfordModelViz.vue?vue&type=template&id=12f173ce&scoped=true"
import script from "./RutherfordModelViz.vue?vue&type=script&lang=js"
export * from "./RutherfordModelViz.vue?vue&type=script&lang=js"
import style0 from "./RutherfordModelViz.vue?vue&type=style&index=0&id=12f173ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f173ce",
  null
  
)

export default component.exports